document.addEventListener('DOMContentLoaded', () => {
  const tabsElement = document.getElementById('tabs');
  const toggleButton = document.getElementById('side-nav-toggle');
  const sideNavContent = document.getElementById('side-nav-content');
  const backdrop = document.getElementById('side-nav-backdrop');

  if (!tabsElement || !toggleButton || !sideNavContent || !backdrop) {
    return;
  }

  const closeAllDropdowns = () => {
    const dropdowns = sideNavContent.querySelectorAll('.nav-item.show');
    dropdowns.forEach(dropdown => {
      dropdown.classList.remove('show');
    });

    const dropdownItems = sideNavContent.querySelectorAll('[data-toggle="dropdown"]');
    dropdownItems.forEach(item => {
      item.setAttribute('aria-expanded', 'false');
    });

    const dropdownMenus = sideNavContent.querySelectorAll('.dropdown-menu.show');
    dropdownMenus.forEach(menu => {
      menu.classList.remove('show');
    });
  };

  const toggleSideNav = () => {
    const isExpanded = tabsElement.getAttribute('data-expanded') === 'true';
    const newState = !isExpanded;

    tabsElement.setAttribute('data-expanded', newState);
    toggleButton.setAttribute('aria-expanded', newState);
    backdrop.setAttribute('data-visible', newState);

    if (newState)
      closeAllDropdowns();
  };

  const closeSideNav = () => {
    tabsElement.setAttribute('data-expanded', 'false');
    toggleButton.setAttribute('aria-expanded', 'false');
    backdrop.setAttribute('data-visible', 'false');
  };

  toggleButton.addEventListener('click', toggleSideNav);

  document.addEventListener('click', (event) => {
    const isExpanded = tabsElement.getAttribute('data-expanded') === 'true';
    if (!isExpanded)
      return;
    const isClickInsideNav = tabsElement.contains(event.target);
    const isClickOnToggle = toggleButton.contains(event.target);
    if (!isClickInsideNav && !isClickOnToggle)
      closeSideNav();
  });

  // Close nav when a nav link is clicked (but not dropdown toggles)
  const navLinks = sideNavContent.querySelectorAll('.nav-link:not(.dropdown-toggle)');
  navLinks.forEach(link => {
    link.addEventListener('click', () => {
      closeSideNav();
    });
  });

  const dropdownToggles = sideNavContent.querySelectorAll('[data-toggle="dropdown"]');
  dropdownToggles.forEach(toggle => {
    toggle.addEventListener('click', (e) => {
      const isExpanded = tabsElement.getAttribute('data-expanded') === 'true';
      if (!isExpanded) return;

      const navItem = toggle.closest('.nav-item');
      const isCurrentlyOpen = navItem?.classList.contains('show');

      // Close all other dropdowns
      sideNavContent.querySelectorAll('.nav-item.show').forEach(item => {
        if (item !== navItem) {
          item.classList.remove('show');
          const otherToggle = item.querySelector('[data-toggle="dropdown"]');
          if (otherToggle) {
            otherToggle.setAttribute('aria-expanded', 'false');
          }
          const otherMenu = item.querySelector('.dropdown-menu');
          if (otherMenu) {
            otherMenu.classList.remove('show');
          }
        }
      });

      // If this dropdown is already open, close it and prevent opening
      if (isCurrentlyOpen) {
        e.preventDefault();
        e.stopPropagation();
        navItem.classList.remove('show');
        toggle.setAttribute('aria-expanded', 'false');
        const menu = navItem.querySelector('.dropdown-menu');
        if (menu) {
          menu.classList.remove('show');
        }
      }
    }, true);
  });
});
